import styles from "./shop.module.css";
import { useState, useEffect } from "react";
import "./shopping.css";
import ReactPaginate from "react-paginate";
import ShopItem from "./shopItem";
import axios from "axios";
import { Link } from "react-router-dom";
import _ from "lodash";
const Shops = ({ itemss, setItemss, updater }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 12;
  const pageVisited = pageNumber * usersPerPage;
  let chars = _.orderBy(itemss, ["mtm"], ["desc"]);

  useEffect(() => {
    let myFormData = new FormData();
    myFormData.append("count", 12);
    myFormData.append("page", 1);
    // setIsLoading(true);
    axios
      .post("http://tatclub.tatdemo.ir/api/getshops", {
        data: myFormData,
      })
      .then(function (response) {
        setItemss(response.data.result);
      })
      .catch(function (err) {
        console.log(err);
      });
  }, [updater]);

  const selectHandler = (id) => {
    setSelectedId(id);
  };

  const pageCountt = Math.ceil(itemss.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <div className={styles.contain}>
      <div className={styles.bgShopText}>آخرین فروشگاه ها</div>
      <div className={styles.divider}></div>
      <div className="row">
        {chars ? (
          chars.slice(pageVisited, pageVisited + usersPerPage).map((item) => {
            return (
              <div className={`  col-lg-3 col-md-6 col-sm-12 my-2  `}>
                <Link to={`/${item.shop_suffix}`} key={item.id}>
                  <ShopItem
                    item={item}
                    key={item.id}
                    onClick={() => selectHandler(item.id)}
                  />
                </Link>
              </div>
            );
          })
        ) : (
          <p>Loading...</p>
        )}
      </div>
      <div className=" d-flex justify-conteny-center">
        <ReactPaginate
          breakLabel={<a href="">...</a>}
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          pageRangeDisplayed={2}
          marginPagesDisplayed={0}
          pageCount={pageCountt}
          onPageChange={changePage}
          containerClassName={"paginationBttn"}
          activeClassName={"paginationActive"}
          disabledClassName={"paginationDisabled"}
          nextLinkClassName={"nextBttn"}
          previousLinkClassName={"previousBttn"}
        />
      </div>
    </div>
  );
};

export default Shops;
